/**
 * calendarCategories — Termin-Kategorien je Betrieb (reine Funktion, Vitest-testbar).
 * Jede Liste endet mit 'Sonstiges'. Fallback für unbekannte/leere Betriebe.
 */
const FALLBACK = ['Besichtigung', 'Abholung', 'Rückgabe', 'Reparatur', 'Besprechung', 'Sonstiges'];

const KATEGORIEN_JE_BETRIEB: Record<string, string[]> = {
  gutachten: ['Besichtigung', 'Schadenaufnahme', 'Nachbesichtigung', 'Beweissicherung', 'Wertgutachten', 'Stellungnahme', 'Besprechung', 'Sonstiges'],
  gutachter_koop: ['Besichtigung', 'Schadenaufnahme', 'Nachbesichtigung', 'Beweissicherung', 'Wertgutachten', 'Stellungnahme', 'Besprechung', 'Sonstiges'],
  autoglas: ['Steinschlag-Reparatur', 'Scheibentausch', 'Kalibrierung', 'Abholung', 'Rückgabe', 'Besprechung', 'Sonstiges'],
  mietwagen: ['Fahrzeug-Übergabe', 'Fahrzeug-Rückgabe', 'Reservierung', 'Aufbereitung', 'Schaden', 'Sonstiges'],
  werkstatt: ['Reparatur', 'Lackierung', 'Inspektion', 'Reifenwechsel', 'Abholung', 'Rückgabe', 'Sonstiges'],
  protex: ['Termin', 'Montage', 'Besprechung', 'Sonstiges'],
  unfallgiganten: ['Beratung', 'Schadenmeldung', 'Besprechung', 'Sonstiges'],
  airbnb: ['Check-in', 'Check-out', 'Reinigung', 'Wartung', 'Sonstiges'],
  recht: ['Besprechung', 'Gerichtstermin', 'Frist', 'Telefonat', 'Sonstiges'],
};

export function kategorienFuerBetrieb(betrieb: string | null | undefined): string[] {
  if (!betrieb) return FALLBACK;
  return KATEGORIEN_JE_BETRIEB[betrieb] ?? FALLBACK;
}
